//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            type: this.$route.query.type || '',
        }
    },
    //生命周期之创建完成
    created: function() {
        if(this.type == 'who'){
            document.title = '北京好中医是谁';
        }
        if(this.type == 'work'){
            document.title = '北京好中医能做什么';
        }
        if(this.type == 'earnings'){
            document.title = '如何获得收益';
        }
        if(this.type == 'store'){
            document.title = '线下实体连锁医馆';
        }
        if(this.type == 'pharmacy'){
            document.title = '北京好中医中央大药房';
        }
        if(this.type == 'issue'){
            document.title = '常见问题';
        }
        if(this.type == 'brand'){
            document.title = '品牌保证';
        }
        if(this.type == 'teach'){
            document.title = '复诊教学';
        }
        if(this.type == 'materials'){
            document.title = '药材甄选';
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/publicity/index.vue